module.exports = __webpack_public_path__ + "img/pop_wallet_logo_HyperPay@2x.79cf8064.png";